module.exports = __webpack_public_path__ + "static/media/DSC03592.5e92ee27.JPG";